import {Link} from 'gatsby';
import React from 'react';
import {buildImageObj, imageUrlFor} from './sanity/image-url';

function PeopleTeaser(props) {
  return (
    <Link to={`/china/partner/${props.slug.current}`} className="tile tile--bw tile--color-hover">
      <figure className="tile__media">
        {props.previewImage && props.previewImage.asset && (
          <img
            className="tile__img" 
            src={imageUrlFor(buildImageObj(props.previewImage))
              .width(576)
              .height(334)
            }
            alt={props.previewImage.alt}
          />
        )}
      </figure>
      <div className="tile__body">
        <strong className="tile__title"><span className="underline">{ props.name[props.language] } </span></strong>
      </div>
    </Link>
  );
}

export default PeopleTeaser;
